"use client"

import CronjobTable from "@/components/cronjob/CronjobTable"
import { CronjobOverviewDomainsSchema } from "@/schemas/cronjob.schema"
import { getCronjobEntries } from "@/services/cronjob.service"
import { useEffect, useState } from "react"
import z from "zod"

export default function CronjobPage(){
    const [dataFetched, setDataFetched] = useState(false);
    const [cronjobEntries, setCronjobEntries] = useState<z.infer<typeof CronjobOverviewDomainsSchema>[]>([]);

    const getEntries = async () => {
        const result = await getCronjobEntries();
        setCronjobEntries(result);
    };

    useEffect(() => {
        if(!dataFetched) {
            setDataFetched(true);
            getEntries();
        }
    }, [cronjobEntries, dataFetched]);

    return (
        <CronjobTable cronjobEntries={cronjobEntries} updateData={getEntries} />
    )
}